export { flattenSearchHistory } from './flattenSearchHistory';
export { removeOutdatedUserSearchHistory } from './removeOutdatedUserSearchHistory';
export { selectUniqueSearches } from './selectUniqueSearches';
export { SearchLocation } from "./types";
export { updateExpiredDates } from './updateExpiredDates';